/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Invite_Email_PlaceholderInputs */

const en_team_invite_email_placeholder = /** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`colleague@yourbusiness.com`)
};

const es_team_invite_email_placeholder = /** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`colega@tunegocio.com`)
};

const fr_team_invite_email_placeholder = /** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`collegue@votreentreprise.com`)
};

const de_team_invite_email_placeholder = /** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kollege@deinunternehmen.com`)
};

const id_team_invite_email_placeholder = /** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rekan@bisnisanda.com`)
};

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const ja_team_invite_email_placeholder = en_team_invite_email_placeholder;

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const zh_team_invite_email_placeholder = en_team_invite_email_placeholder;

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const ar_team_invite_email_placeholder = en_team_invite_email_placeholder;

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const it_team_invite_email_placeholder = en_team_invite_email_placeholder;

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const ru_team_invite_email_placeholder = en_team_invite_email_placeholder;

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const pt_team_invite_email_placeholder = en_team_invite_email_placeholder;

/** @type {(inputs: Team_Invite_Email_PlaceholderInputs) => LocalizedString} */
const ko_team_invite_email_placeholder = en_team_invite_email_placeholder;

/**
* | output |
* | --- |
* | "colleague@yourbusiness.com" |
*
* @param {Team_Invite_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_email_placeholder = /** @type {((inputs?: Team_Invite_Email_PlaceholderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_Email_PlaceholderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_email_placeholder(inputs)
	if (locale === "es") return es_team_invite_email_placeholder(inputs)
	if (locale === "fr") return fr_team_invite_email_placeholder(inputs)
	if (locale === "de") return de_team_invite_email_placeholder(inputs)
	if (locale === "ja") return ja_team_invite_email_placeholder(inputs)
	if (locale === "zh") return zh_team_invite_email_placeholder(inputs)
	if (locale === "ar") return ar_team_invite_email_placeholder(inputs)
	if (locale === "id") return id_team_invite_email_placeholder(inputs)
	if (locale === "it") return it_team_invite_email_placeholder(inputs)
	if (locale === "ru") return ru_team_invite_email_placeholder(inputs)
	if (locale === "pt") return pt_team_invite_email_placeholder(inputs)
	return ko_team_invite_email_placeholder(inputs)
});